import React from "react";
import { useState, useEffect } from "react";
import styles from "./style.module.css";
import { Accordion } from "aible";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import { useDispatch, useSelector } from "types/store";
import CapabilityItem from "components/Templates/CapabilityItem";
const ChatCapabilityList = ({ defaultShow, agentStepsOverride, agentStepTypeOverride, listOnly, onFinishAction, currentViewMessage }) => {
    const dispatch = useDispatch();
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const chatFlow = useSelector((state) => chatGPTReducer.getChatFlow(state));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const agentSteps = useSelector((state) => chatGPTReducer.getAgentSteps(state));
    const currentAgentStep = useSelector((state) => chatGPTReducer.getCurrentAgentStep(state));
    const agentStepsType = useSelector((state) => chatGPTReducer.getAgentStepsType(state));
    const showCollapsedAgentStep = useSelector((state) => chatGPTReducer.getShowCollapsedAgentStep(state));
    const retCapabilities = useSelector((state) => {
        if (agentStepsOverride) {
            return [...agentStepsOverride];
        }
        else if (agentStepTypeOverride) {
            const nAgentSteps = chatGPTReducer.getAgentSteps(state, agentStepTypeOverride);
            return nAgentSteps;
        }
        else {
            return [...agentSteps];
        }
    });
    const collapsedAgentStepIndex = retCapabilities.findIndex((capability) => capability?.id === showCollapsedAgentStep?.id);
    const currentStepIndex = agentSteps?.findIndex((agentStep) => agentStep?.id === currentAgentStep?.id);
    const summarizationStepIndex = agentSteps?.findIndex((agentStep) => agentStep?.id === "SUMMARIZATION");
    const shouldShowCharts = currentStepIndex >= summarizationStepIndex;
    const clawAgentStepIndex = agentSteps?.findIndex((agentStep) => agentStep?.id === "CREATE_CLAW");
    const shouldShowCreateClaw = currentStepIndex >= clawAgentStepIndex;
    const [showAccordion, updateShowAccordion] = useState(defaultShow);
    // const [delayedIsAsking, updateDelayedIsAsking] = useState<boolean | undefined>(false);
    const [onFinishTimeout, updateOnFinishTimeout] = useState(undefined);
    useEffect(() => {
        if (showCollapsedAgentStep !== undefined &&
            isAsking &&
            showAccordion &&
            showCollapsedAgentStep?.id !== "CREATE_CLAW") {
            updateShowAccordion(false);
        }
        else if (showCollapsedAgentStep === undefined && isAsking && !showAccordion) {
            updateShowAccordion(true);
        }
    }, [isAsking, showCollapsedAgentStep]);
    // useEffect(() => {
    //   if (currentAgentStep) {
    //     dispatch(chatGPTReducer.resetAgentStep());
    //   }
    // }, [agentStepsType]);
    useEffect(() => {
        if (onFinishAction) {
            const finalAgentStep = retCapabilities?.[retCapabilities?.length - 1];
            if (currentAgentStep && finalAgentStep?.id === currentAgentStep?.id) {
                if (onFinishTimeout) {
                    clearTimeout(onFinishTimeout);
                }
                const retAction = onFinishAction === "OPEN" ? true : false;
                const newTimeout = setTimeout(() => updateShowAccordion(retAction), 1000);
                updateOnFinishTimeout(newTimeout);
            }
        }
    }, [currentAgentStep]);
    if (retCapabilities?.length < 1) {
        return React.createElement(React.Fragment, null);
    }
    if (listOnly) {
        return (React.createElement("div", { className: styles.reasoningCapabilitiesContainer, style: { marginTop: "0px" } }, retCapabilities.map((capability, index) => {
            return (React.createElement(CapabilityItem, { type: capability, index: index, key: capability?.label + "___" + index, active: currentAgentStep?.id === capability?.id, currentViewMessage: currentViewMessage }));
        })));
    }
    return (React.createElement("div", { className: styles.reasoningCapabilitiesListContainer },
        React.createElement(Accordion, { show: showAccordion === true, header: React.createElement("div", { style: { display: "flex", flexDirection: "column", width: "100%", paddingRight: "20px" } },
                React.createElement("div", { className: styles.reasoningStepsAccordionHeader }, "Agent Steps"),
                showCollapsedAgentStep && !showAccordion && (React.createElement("div", { style: { marginTop: "10px" } },
                    React.createElement(CapabilityItem, { type: showCollapsedAgentStep, index: collapsedAgentStepIndex, active: true, currentViewMessage: currentViewMessage, showCharts: shouldShowCharts && collapsedAgentStepIndex === summarizationStepIndex, showMessages: true })))), onToggle: () => updateShowAccordion(!showAccordion) },
            React.createElement("div", { className: styles.reasoningCapabilitiesContainer }, retCapabilities.map((capability, index) => {
                return (React.createElement(CapabilityItem, { onClick: !shouldShowCreateClaw && capability?.id === "CREATE_CLAW"
                        ? () => {
                            dispatch(chatGPTReducer.updateCurrentAgentStepId(capability?.id));
                        }
                        : undefined, type: capability, index: index, key: capability?.label + "___" + index, active: currentAgentStep?.id === capability?.id, currentViewMessage: currentViewMessage, showCharts: (shouldShowCharts || !currentAgentStep) && index === summarizationStepIndex, showCreateClaw: shouldShowCreateClaw, showMessages: currentStepIndex >= index, showAccordion: showAccordion }));
            })))));
};
export default ChatCapabilityList;
